import { TemplateConfig } from '../types';

export const developmentSpreadConfig: TemplateConfig = {
  id: 'development-spread',
  name: '发展牌阵',
  description: '分析事情的发展情况和各阶段状况',
  cardCount: 5,
  
  fieldDefaults: {
    title: '发展牌阵',
    customerQuestion: '**这件事的发展情况**',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 1 行第 3 张牌',
      '请输入第 1 行第 4 张牌',
      '请输入第 1 行第 5 张牌'
    ],
    cardInfos: [
      '开端，也就是选择这个工作之后，比较短期的时间内情况是怎样的',
      '发展，也就是选择这个工作的话，经过一段时间之后情况又是怎样',
      '阻碍，也就是选择这个工作的话，你会感觉到事业上有什么阻碍',
      '结果，也就是选择这个工作的话，你在最终会感觉到这份工作给你带来了怎样的后果以及影响',
      '对这件事的建议，也就是你该不该选择这份工作，选择这份工作的话又该以怎样的态度去对待'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#52c41a',
    backgroundColor: '#f6ffed',
    icon: '📈'
  }
};